/** スポット一覧のタブ（0 = マップ, 1 = リスト） */
export type SpotTab = 0 | 1

/** タブを表す URL クエリのキー */
const SPOT_TAB_QUERY_KEY = 'tab'

/** リストタブを表す URL クエリ `?tab=` の値。マップは既定のためクエリを付けない（#3665） */
export const SPOT_TAB_QUERY_LIST = 'list'

/**
 * URL クエリ `tab` からスポット一覧のタブを決める（#3665）。
 * `list` 以外（未指定・配列・不明な値）はすべて既定のマップにする。
 */
export const resolveSpotTabParam = (tab: string | string[] | undefined): SpotTab =>
  tab === SPOT_TAB_QUERY_LIST ? 1 : 0

/**
 * 現在のアドレス（パス + クエリ）から、指定タブを表す URL を組み立てる。`tab` 以外のクエリはそのまま残す。
 *
 * `{ pathname: router.pathname, query: router.query }` から組み立てないこと。
 * 本番は全スラッグを `/[campaign]/...` のシェル HTML で配信しており、クエリなしで開いたページでは
 * `router.query.campaign` が空のままになる。その状態で動的ルートのパターンを渡すと補間できず、
 * アドレスが `/[campaign]/spots/?tab=list` というリテラルに書き換わる。
 *
 * @param currentUrl `window.location.pathname + window.location.search`
 */
export const buildSpotTabUrl = (currentUrl: string, tab: SpotTab): string => {
  const [path, search = ''] = currentUrl.split('#')[0].split('?')
  const params = new URLSearchParams(search)
  params.delete(SPOT_TAB_QUERY_KEY)
  if (tab === 1) params.set(SPOT_TAB_QUERY_KEY, SPOT_TAB_QUERY_LIST)
  const query = params.toString()
  return query ? `${path}?${query}` : path
}
